import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/layout/AppSidebar";
import { BottomNav } from "@/components/layout/BottomNav";
import { useIsMobile } from "@/hooks/use-mobile";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { TrendingUp } from "lucide-react";

const routeTitles: Record<string, string> = {
  "/": "Platform Overview",
  "/admin/businesses": "Businesses",
  "/admin/users": "Users",
  "/admin/alerts": "Insights",
  "/admin/finance": "Finance",
  "/admin/system": "System",
  "/admin/subscriptions": "Subscriptions",
};

function getPageTitle(pathname: string): string {
  if (routeTitles[pathname]) return routeTitles[pathname];
  if (/^\/admin\/businesses\/.+/.test(pathname)) return "Business Detail";
  return "Admin Dashboard";
}

export function AppLayout() {
  const isMobile = useIsMobile();
  const location = useLocation();
  const navigate = useNavigate();
  const isAlertsActive = location.pathname === "/admin/alerts";

  const pageTitle = getPageTitle(location.pathname);

  return (
    <SidebarProvider>
      <div className="flex min-h-[100dvh] w-full">
        {!isMobile && <AppSidebar />}
        <div className="flex flex-1 flex-col min-w-0">
          <header className="sticky top-0 z-30 flex h-14 items-center gap-3 border-b bg-card/80 backdrop-blur-sm px-4">
            {!isMobile && <SidebarTrigger aria-label="Toggle sidebar" />}
            <span className="text-sm font-medium text-foreground md:text-muted-foreground">{pageTitle}</span>
            <div className="flex-1" />
            {isMobile && (
              <button
                onClick={() => navigate("/admin/alerts")}
                className={`p-2 rounded-md transition-colors ${isAlertsActive ? "text-brand" : "text-muted-foreground hover:text-foreground"}`}
                aria-label="Insights"
              >
                <TrendingUp className="h-5 w-5" />
              </button>
            )}
          </header>
          <main className="flex-1 overflow-y-auto pb-20 md:pb-6">
            <Outlet />
          </main>
        </div>
        {isMobile && <BottomNav />}
      </div>
    </SidebarProvider>
  );
}
